// extracted by mini-css-extract-plugin
export const root = "initiatives-partners-module--root--3wasO";